/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementCreateMemberPointResponse } from './MemberManagementCreateMemberPointResponse';

export type MemberManagementCreateMemberPointResponseApiRespoonse = {
    data?: MemberManagementCreateMemberPointResponse;
    status?: MemberManagementCreateMemberPointResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementCreateMemberPointResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

